import * as React from "react";
import { Dropdown } from "../../../forms/informedv4/DropdownV4";
import { Scope, Input } from "informedv4";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { HasPermission } from "../../../misc/components/Authorization";
import { nameof } from "ts-simple-nameof";
import { CommentEntry, DefaultCommentFormModel } from "./FixedCommentsTable";
import { FixedCommentSet } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../Core/SecurityContext";

interface DefaultAcceptableCommentDropdownProps {
    set: FixedCommentSet;
    onChange(setId, defaultAcceptableCommentId) : void;
    value: string;
}

export enum DefaultFixedCommentOptionTypes {
    None = "DFC_NONE"
}

export const DefaultAcceptableCommentDropdown = ({ set, onChange, value }: DefaultAcceptableCommentDropdownProps): JSX.Element => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (!!set ? <Scope scope={`${nameof<DefaultCommentFormModel>(s => s.defaultComments)}[${set.id}]`}>
        <Dropdown name={nameof<CommentEntry>(s => s.DefaultComment)} initialValue={value} field={nameof<CommentEntry>(s => s.DefaultComment)} onChange={(evt)=> onChange(set.id, (evt as any).target.value)} disabled={!HasPermission(currentUserPermissions, study.id, PermissionEnum.EditFixedComment)}>
            <option value={DefaultFixedCommentOptionTypes.None}></option>
            {set.comments.map(c => (<option key={c.id} value={c.id}>{c.comment}</option>))}
        </Dropdown>
        <Input name={nameof<CommentEntry>(s => s.SetType)} field={nameof<CommentEntry>(s => s.SetType)} hidden={true} />
    </Scope> : <>-</>);
}
